import { render } from "./JudgeRoundTable.vue?vue&type=template&id=17b33a0e&scoped=true"
import script from "./JudgeRoundTable.vue?vue&type=script&lang=js"
export * from "./JudgeRoundTable.vue?vue&type=script&lang=js"

import "./JudgeRoundTable.vue?vue&type=style&index=0&id=17b33a0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b33a0e"]])

export default __exports__